import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  show: false,
  message: '',
  type: 'success', // success | danger | warning | info
  duration: 3000 // ms
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    showAlert: (state, action) => {
      const { message, type = 'success', duration = 3000 } = action.payload;
      state.show = true;
      state.message = message;
      state.type = type;
      state.duration = duration;
    },
    hideAlert: (state) => {
      state.show = false;
      state.message = '';
    }
  }
});

export const { showAlert, hideAlert } = alertSlice.actions;
export default alertSlice.reducer;
